import { useState } from "react";
import { mockActiveTickets } from "../../../mocks/account";

const packageColors: Record<string, string> = {
  Starter: "bg-sky-100 text-sky-700",
  Classique: "bg-orange-100 text-orange-700",
  Premium: "bg-emerald-100 text-emerald-700",
  Gold: "bg-amber-100 text-amber-700",
  Platinum: "bg-violet-100 text-violet-700",
  "Duo / Famille": "bg-rose-100 text-rose-700",
};

export default function TicketsList() {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");

  const packages = [...new Set(mockActiveTickets.map((t) => t.package))];
  const filtered = mockActiveTickets.filter((t) => {
    const matchSearch = t.id.toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === "all" || t.package === filter;
    return matchSearch && matchFilter;
  });

  return (
    <div>
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
          <h2 className="font-bold text-slate-900 text-xl font-playfair">Meine aktiven Lose</h2>
          <p className="text-slate-500 text-sm mt-0.5">
            Ziehung #52 — {mockActiveTickets.length} Lose nehmen teil
          </p>
        </div>
        <div className="flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold">
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-checkbox-circle-line"></i></span>
          Alle aktiv
        </div>
      </div>

      {/* Filters */}
      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-slate-400">
            <i className="ri-search-line text-sm"></i>
          </span>
          <input
            type="text"
            placeholder="Nummer suchen..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-white border border-slate-200 rounded-xl pl-9 pr-4 py-2.5 text-sm focus:outline-none focus:border-secondary transition-colors"
          />
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <button
            onClick={() => setFilter("all")}
            className={`px-4 py-2 rounded-full text-xs font-semibold cursor-pointer whitespace-nowrap transition-all ${filter === "all" ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-slate-300"}`}
          >
            Alle ({mockActiveTickets.length})
          </button>
          {packages.map((pkg) => (
            <button
              key={pkg}
              onClick={() => setFilter(pkg)}
              className={`px-4 py-2 rounded-full text-xs font-semibold cursor-pointer whitespace-nowrap transition-all ${filter === pkg ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-slate-300"}`}
            >
              {pkg} ({mockActiveTickets.filter((t) => t.package === pkg).length})
            </button>
          ))}
        </div>
      </div>

      {/* Tickets Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {filtered.map((ticket) => (
          <div
            key={ticket.id}
            className="bg-white border border-slate-100 rounded-xl p-4 flex items-center justify-between group hover:border-sky-200 hover:bg-sky-50/40 transition-all duration-200"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-sky-100 transition-colors">
                <i className="ri-ticket-2-line text-slate-500 group-hover:text-sky-500 transition-colors"></i>
              </div>
              <div>
                <p className="font-mono text-slate-800 text-sm font-semibold tracking-wider">{ticket.id}</p>
                <p className="text-slate-400 text-xs mt-0.5">{ticket.date}</p>
              </div>
            </div>
            <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${packageColors[ticket.package] || "bg-slate-100 text-slate-600"}`}>
              {ticket.package}
            </span>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="text-center py-12 text-slate-400">
          <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
            <i className="ri-search-line text-3xl"></i>
          </div>
          <p>Keine Lose gefunden</p>
        </div>
      )}

      {/* Bottom info */}
      <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-xl flex items-start gap-3">
        <span className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
          <i className="ri-information-line text-primary"></i>
        </span>
        <p className="text-amber-800 text-sm leading-relaxed">
          Bewahren Sie Ihre Nummern sicher auf. Sie werden mit der gezogenen Nummer bei der Ziehung #52 am 15. April 2025 um 20:00 Uhr in Anwesenheit eines Notars verglichen.
        </p>
      </div>
    </div>
  );
}
